import { useNavigate } from "react-router-dom";

import { TeamMemberForm } from "../../TeamMemberForm";
import { TEAM_MEMBERS_QUERY } from "../../TeamMembers/TeamMembersQuery";

import { useTeamMemberCreateMutation } from "./TeamMemberCreateMutation";
import type { TeamMemberCreateVariables } from "./TeamMemberCreateMutation";

const TeamMemberNew = () => {
  const navigate = useNavigate();
  const [createTeamMember] = useTeamMemberCreateMutation({
    refetchQueries: [{ query: TEAM_MEMBERS_QUERY }],
    onCompleted: data => {
      console.log("We've encountered the following errors whenever creating a team member");
      console.error(JSON.stringify(data.createTeamMember.teamMemberErrors));
      console.error(JSON.stringify(data.createTeamMember.listingAgentErrors));
    },
    onError: error => {
      console.log("We've encountered the following error whenever creating a team member");
      console.error(error.message);
    },
  });

  const handleSave = async (teamMember: TeamMemberCreateVariables) => {
    const { data } = await createTeamMember({ variables: teamMember });

    if (data?.createTeamMember?.teamMember?.slug) {
      navigate(`/team_members/${data.createTeamMember.teamMember.slug}`);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <TeamMemberForm onCreate={handleSave} />
      </div>
    </div>
  );
};

export { TeamMemberNew };
